/**
 * HDM Custom Event Tracker Hook
 * Registers custom event handlers for HDM-specific events.
 */
import { EventsContext } from '@/data/context/events';
import { hdmCreateAccountCompleteDelegator } from '@/data/events/delegators/HDMCreateAccountComplete';
import { hdmLoginCompleteDelegator } from '@/data/events/delegators/HDMLoginComplete';
import { useContext, useEffect } from 'react';

const warn = (event: string) => {
	if (process.env.NODE_ENV !== 'production') {
		console.warn(
			`Create a hook inside 'presentation/events/hooks' to handle this event '${event}'`
		);
	}

	return Promise.resolve();
};

export const useEventTracker = () => {
	const { registerEvent } = useContext(EventsContext);

	useEffect(() => {
		registerEvent('onPageView', () => {
			warn('onPageView');
		});
		registerEvent('onAddToCart', () => warn('onAddToCart'));
		registerEvent('onCategoryView', () => warn('onCategoryView'));
		registerEvent('onProductView', () => warn('onProductView'));
		registerEvent('onProductClick', () => warn('onProductClick'));
		registerEvent('onCheckout', () => warn('onCheckout'));
		registerEvent('onCheckoutShipping', () => warn('onCheckoutShipping'));
		registerEvent('onCheckoutPayment', () => warn('onCheckoutPayment'));
		registerEvent('onPromotionClick', () => warn('onPromotionClick'));
		registerEvent('onPromotionView', () => warn('onPromotionView'));
		registerEvent('onSearchResultsView', () => warn('onSearchResultsView'));
		registerEvent('onItemListView', () => warn('onItemListView'));
		registerEvent('onCartView', () => warn('onCartView'));
		registerEvent('onCartPageView', () => warn('onCartPageView'));
		registerEvent('onRemoveFromCart', () => warn('onRemoveFromCart'));
		registerEvent('onCheckoutPageView', () => warn('onCheckoutPageView'));
		registerEvent('onPurchase', () => warn('onPurchase'));

		// TODO: move custom events to `presentation/events/hooks`
		registerEvent('onHDMLoginComplete', hdmLoginCompleteDelegator);
		registerEvent('onHDMCreateAccountComplete', hdmCreateAccountCompleteDelegator);
	}, [registerEvent]);
};
